import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { immerv } from '../../shared/common-packages/immer';

const MODEL_NAME = 'APP_NAVIGATION_MENUS';

export class AddMenuGroup {
  static readonly type = MODEL_NAME + ' AddMenuGroup';
  constructor(public payload: any) {}
}

export class RemoveMenuGroup {
  static readonly type = MODEL_NAME + ' RemoveMenuGroup';
}

export class AddMenu {
  static readonly type = MODEL_NAME + ' AddMenu';
  constructor(public payload: any) {}
}

export class RemoveMenu {
  static readonly type = MODEL_NAME + ' RemoveMenu';
}

export class ResetMenu {
  static readonly type = MODEL_NAME + ' ResetMenu';
}

export class SideMenuModel {
  static id = MODEL_NAME;
  nav!: any[];
}

@State<SideMenuModel>({
  name: MODEL_NAME,
  defaults: { nav: [] },
})
@Injectable()
export class SideMenuStore implements NgxsOnInit {
  ngxsOnInit(ctx: StateContext<SideMenuModel>): void {
    // Optionally, initialize the menu state here if needed
    // For now, ensure nav is always an array
    const state = ctx.getState();
    if (!Array.isArray(state.nav)) {
      ctx.setState({ ...state, nav: [] });
    }
  }

  @Selector()
  public static navMenu(state: SideMenuModel) {
    return state.nav;
  }

  @Action(AddMenuGroup)
  public AddMenuGroup(
    { setState, getState }: StateContext<SideMenuModel>,
    { payload }: any
  ) {
    setState(immerv((s: SideMenuModel) => s.nav.push(payload)));
  }

  @Action(AddMenu)
  public AddMenu(
    { setState, getState }: StateContext<SideMenuModel>,
    { payload }: any
  ) {
    setState(immerv((s: SideMenuModel) => s.nav.push(payload)));
  }


  @Action(ResetMenu)
  public ResetMenu({ setState }: StateContext<SideMenuModel>) {
    setState(immerv((s: SideMenuModel) => (s.nav = [])));
  }
}
